import Swal from "sweetalert2";
import { cnpj, cpf } from "cpf-cnpj-validator";

export interface ValidationResult {
  isValid: boolean;
  shouldClearField?: boolean;
}

export const validateBasicFields = (customerForm: any, fieldsConfig: any[], haveFieldConfig: boolean) => {
  if (haveFieldConfig) {
    const emailField = fieldsConfig.find(field => field.name === "email");
    const birthField = fieldsConfig.find(field => field.name === "dataNascimento");
    const genderField = fieldsConfig.find(field => field.name === "genero");
    const phoneField = fieldsConfig.find(field => field.name === "telefone");



    return {
      isValid: customerForm.cpfOrCnpj &&
        customerForm.name &&
        verifyField(emailField, customerForm.email) &&
        verifyField(genderField, customerForm.gender) &&
        verifyField(birthField, customerForm.birthdate, customerForm.selectedDoc === "cpf") &&
        verifyField(phoneField, customerForm.telephone, customerForm.selectedDoc === "cpf"),
      phoneField,
      emailField
    };
  }

  return {
    isValid: customerForm.cpfOrCnpj && customerForm.email &&
      customerForm.gender && customerForm.birthdate &&
      customerForm.telephone && customerForm.name,
    phoneField: { mandatory: true },
    emailField: { mandatory: true }
  };
};

export const validateBasicFieldsWithAddress = (customerForm: any, fieldsConfig: any[], haveFieldConfig: boolean) => {
  const basicValidation = validateBasicFields(customerForm, fieldsConfig, haveFieldConfig);

  const addressValid = customerForm.cep &&
    customerForm.address &&
    customerForm.district &&
    customerForm.city &&
    customerForm.state &&
    customerForm.number;

  return {
    ...basicValidation,
    isValid: basicValidation.isValid && addressValid
  };
};

export const validatePhone = (phone: string, isRequired: boolean): ValidationResult => {
  if (!isRequired) return { isValid: true };

  if (phone.includes("_")) {
    Swal.fire({
      icon: "warning",
      title: "Atenção!",
      text: "Telefone inválido",
    });
    return { isValid: false, shouldClearField: true };
  }
  return { isValid: true };
};

export const validateName = (name: string): ValidationResult => {
  if (name.split(" ").length < 2 ||
    !name.split(" ")[1] ||
    name.split(" ")[1] === "") {
    Swal.fire({
      icon: "warning",
      title: "Nome inválido!",
      text: "Informe seu sobrenome",
    });
    return { isValid: false };
  }
  return { isValid: true };
};

export const validateDocument = (document: string): ValidationResult => {
  if (document.includes("_")) {
    Swal.fire({
      icon: "warning",
      title: "Atenção!",
      text: "CPF/CNPJ inválido",
    });
    return { isValid: false, shouldClearField: true };
  }

  const clearDocument = cpf.strip(document);

  if (clearDocument.length <= 11 && !cpf.isValid(document)) {
    Swal.fire({
      icon: "warning",
      title: "Atenção!",
      text: "CPF inválido",
    });
    return { isValid: false };
  }

  if (clearDocument.length > 11 && !cnpj.isValid(document)) {
    Swal.fire({
      icon: "warning",
      title: "Atenção!",
      text: "CNPJ inválido",
    });
    return { isValid: false };
  }

  return { isValid: true };
};

export const validateEmail = (email: string, isRequired: boolean): ValidationResult => {
  if (!isRequired) return { isValid: true };

  if (!email.includes("@")) {
    Swal.fire({
      icon: "warning",
      title: "Atenção!",
      text: "E-mail inválido",
    });
    return { isValid: false, shouldClearField: true };
  }
  return { isValid: true };
};

export const validateCep = (cep: string): ValidationResult => {
  if (cep.includes("_")) {
    Swal.fire({
      icon: "warning",
      title: "Atenção!",
      text: "CEP inválido",
    });
    return { isValid: false, shouldClearField: true };
  }
  return { isValid: true };
};

export const showValidationError = () => {
  Swal.fire({
    icon: "error",
    title: "Erro",
    text: "Verifique se preencheu todos os campos",
  });
};

export const showApiError = () => {
  Swal.fire({
    icon: "error",
    title: "Erro!",
    text: "Falha ao cadastrar cliente",
  });
};

const verifyField = (field: any, value: string, isCPF: boolean = true) => {
  // Só verifica se for obrigatório E visível
  if (field && field.mandatory && field.visible && isCPF) {
    return value !== "";
  }
  return true;
};